import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';

import {
    CalculatorStepPanel,
    Sizes,
    InputSelector,
} from '@ratehub/base-ui';
import {
    MORTGAGE_PLACEHOLDERS,
} from '@ratehub/mtg-common';

import CalculatorGridStyles from '../styles/CalculatorGridStyles';
import CalculationGridRows from './CalculationGridRows';


function DownPaymentCalculatorScenarioStep({
    stepNumber,
    scenarioCount,
    ...otherProps
}) {
    return (
        <Container
            stepNumber={stepNumber}
            includeInnerPadding={false}
            isVisible
            $columnCount={scenarioCount}
            {...otherProps}
        >
            <div className="topContainer">
                <div className="row flex-container">
                    <label
                        className="col-0 label"
                        htmlFor="askingPrice"
                    >
                        <FormattedMessage
                            id="mtg-calculator.DownPaymentCalculatorInputs.askingPriceLabel"
                            defaultMessage="Asking price"
                        />
                    </label>

                    <div className="col-1 input-container">
                        <InputSelector
                            aria-label={(
                                <FormattedMessage
                                    id="mtg-calculator.DownPaymentCalculatorInputs.askingPriceAriaLabel"
                                    defaultMessage="Asking price"
                                />
                            )}
                            field={{
                                name: 'askingPrice',
                                type: 'integer',

                            }}
                            type="currency"
                            placeholder={MORTGAGE_PLACEHOLDERS.AMOUNT_PLACEHOLDER}
                        />
                    </div>
                </div>

                <hr className="rh-horizontal-rule rh-width-100p" />
            </div>

            <CalculationGridRows
                className="grid"
                scenarioCount={scenarioCount}
            />
        </Container>
    );
}

DownPaymentCalculatorScenarioStep.propTypes = {
    stepNumber: PropTypes.number.isRequired,
    scenarioCount: PropTypes.number.isRequired,
};

const Container = styled(CalculatorStepPanel)`
    > .topContainer {
        padding: 0 ${Sizes.SPACING.ONE};

        ${CalculatorGridStyles};

        > .flex-container {
            padding: 0;

            > .label {
                //padding-left added to align label with next section labels
                padding-left: 1.325rem;
            }

            > .input-container {
                grid-column: 2/4;
            }

            ${({ $columnCount }) => $columnCount <= 2 && `
                display: block;

                > .label {
                    padding: 0;
                    margin-bottom: ${Sizes.SPACING.ONE};
                }
            `}
        }
    }

    > .grid {
        ${CalculatorGridStyles};

        > .row {
            &--blue-light {
                border-radius : 0 0 0.375rem 0.375rem;
            }
        }
    }
`;

export default observer(DownPaymentCalculatorScenarioStep);
